
// /* ===============================
//    HOOK INTO QUICK ADD MODAL
//    =============================== */
// function initTileCalculator(container) {
//   const infoElems = container.querySelectorAll(':scope .product__info-container');
//   infoElems.forEach((infoElem)=>{

//   console.log("infoElem",infoElem);

//   const wrapper = infoElem.querySelector('.coverage-with-boxes-input-main');
//   if (!wrapper) return;

//   const sqftInput = infoElem.querySelector('.input-field-sqft');
//   console.log("sqftInput",sqftInput);
//   const boxesInput = infoElem.querySelector('.input-field-qut');
//   const wastageCheckbox = container.querySelector('.wastage-checkbox input[type="checkbox"]');
//   console.log("wastageCheckbox",wastageCheckbox);
//   const errorDiv = infoElem.querySelector('.error-add');
//   const calculatorWrapper = infoElem.querySelector('#product-calculator');
//   const totalPriceElement = infoElem.querySelector('#total-price');
//   const coverageMessage = infoElem.querySelector('#product-coverage');
//   const oneBoxPrice = parseFloat(wrapper.getAttribute('one-box-price')) / 100 || 0;
//   const themeBtn = infoElem.querySelector('.theme-btn');
//   const cstBtn = infoElem.querySelector('.cst-btn');
//   const shopifyQuantityInput = infoElem.querySelector('.quantity__input');

//   if (!sqftInput || !boxesInput || !wastageCheckbox) return;

//   const sqftPerBox = parseFloat(wrapper.dataset.sqftPerBox) || 1;
//   let rawSqft = 0;
//   let manualSqftValue = 0;
//   let isSyncing = false;

//   function clearError() {
//     if (calculatorWrapper && errorDiv) {
//       calculatorWrapper.classList.remove('error-box');
//       errorDiv.innerHTML = '';
//       errorDiv.style.display = 'none';
//     }
//   }

//   function showError(message) {
//     if (!calculatorWrapper || !errorDiv) return;

//     // Prevent quick-add modal from writing to main product's errorDiv
//     if (!container.contains(errorDiv)) return;

//     const errorIcon = `
//       <svg height="20" width="20" style="overflow:visible;enable-background:new 0 0 32 32; vertical-align: middle; margin-right: 6px;" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
//         <g id="Error_1_">
//           <g id="Error">
//             <circle cx="16" cy="16" r="16" style="fill:#D72828;" />
//             <path d="M14.5,25h3v-3h-3V25z M14.5,6v13h3V6H14.5z" style="fill:#E6E6E6;" />
//           </g>
//         </g>
//       </svg>
//     `;
//     errorDiv.innerHTML = `
//       <div class="error-msg" style="display:flex; align-items:center; gap: 6px;">
//         ${errorIcon}<span>${message}</span>
//       </div>
//     `;
//     console.log("errorDiv111",errorDiv);
//     errorDiv.style.display = 'block';
//     calculatorWrapper.classList.add('error-box');
//   }



//   function updateTotalAndCoverage() {
//     const boxes = parseFloat(boxesInput.value) || 0;
//     const total = boxes * oneBoxPrice;
//     totalPriceElement.textContent = `$${total.toFixed(2)}`;
//     coverageMessage.style.display = boxes > 0 ? 'none' : 'block';
//   }




//   // Prevent wastage check if no input
//   wastageCheckbox.addEventListener('change', function () {
//     console.log("checkbox changed...");
//     let sqft = parseFloat(sqftInput.value) || 0;
//     let boxes = parseFloat(boxesInput.value) || 0;
//     if (this.checked && sqft <= 0 && boxes <= 0) {
//       this.checked = false;
//       showError('Please enter a valid Sqft or Boxes before applying 10% wastage.');
//       isSyncing = false;
//     }
//   });

//   // SQFT → BOXES
//   sqftInput.addEventListener('input', function () {
//     clearError();
//     if (isSyncing) return;
//     isSyncing = true;
//     let sqft = parseFloat(sqftInput.value) || 0;
//     manualSqftValue = wastageCheckbox.checked ? sqft / 1.1 : sqft;
//     rawSqft = manualSqftValue;
//     if (rawSqft > 0) {
//       const boxes = Math.ceil(rawSqft / sqftPerBox);
//       boxesInput.value = boxes;
//       boxesInput.dispatchEvent(new Event('input', { bubbles: true }));
//     } else {
//       boxesInput.value = '';
//       boxesInput.dispatchEvent(new Event('input', { bubbles: true }));
//     }
//     sqftInput.dispatchEvent(new Event('change', { bubbles: true }));
//     updateTotalAndCoverage();
//     isSyncing = false;
//   });

//   // BOXES → SQFT
//   boxesInput.addEventListener('input', function () {
//     clearError();
//     if (isSyncing) return;
//     isSyncing = true;
//     const boxes = parseFloat(boxesInput.value) || 0;
//     if (boxes <= 0) {
//       sqftInput.value = '';
//       updateTotalAndCoverage();
//       if (wastageCheckbox.checked) {
//         wastageCheckbox.checked = false;
//         showError('10% wastage removed — box quantity must be greater than 0.');
//       }
//       isSyncing = false;
//       return;
//     }
//     rawSqft = boxes * sqftPerBox;
//     manualSqftValue = rawSqft;
//     sqftInput.value = wastageCheckbox.checked ? (rawSqft * 1.1).toFixed(2) : rawSqft.toFixed(2);
//     sqftInput.dispatchEvent(new Event('input', { bubbles: true }));
//     sqftInput.dispatchEvent(new Event('change', { bubbles: true }));
//     updateTotalAndCoverage();
//     isSyncing = false;
//   });

//   // WASTAGE CHECKBOX CHANGE
//   wastageCheckbox.addEventListener('change', function () {
//     if (isSyncing) return;
//     isSyncing = true;
//     let sqft = manualSqftValue || 0;
//     sqft = wastageCheckbox.checked ? sqft * 1.1 : sqft;
//     sqftInput.value = sqft.toFixed(2);
//     const displayedSqft = parseFloat(sqftInput.value) || 0;
//     const boxes = displayedSqft > 0 ? Math.ceil(displayedSqft / sqftPerBox) : '';
//     boxesInput.value = boxes;
//     sqftInput.dispatchEvent(new Event('change', { bubbles: true }));
//     updateTotalAndCoverage();
//     if (shopifyQuantityInput) shopifyQuantityInput.value = boxes;
//     isSyncing = false;
//   });

//   // Quantity pass to cart
//   boxesInput.addEventListener('input', function () {
//     const boxValue = parseInt(boxesInput.value);
//     if (shopifyQuantityInput) shopifyQuantityInput.value = (!isNaN(boxValue) && boxValue >= 1) ? boxValue : 0;
//   });

//   // Validation for custom button
//   if (themeBtn && cstBtn) {
//     const isSoldOut = themeBtn.hasAttribute('disabled');
//     function toggleButtons(value) {
//       const floatVal = parseFloat(value);
//       if (!value || floatVal <= 0 || !Number.isInteger(floatVal)) {
//         if (!isSoldOut) {
//           themeBtn.hidden = true;
//           cstBtn.style.display = 'block';
//         }
//       } else {
//         if (!isSoldOut) {
//           themeBtn.hidden = false;
//           cstBtn.style.display = 'none';
//         }
//       }
//       clearError();
//     }
//     input = boxesInput;
//     input.addEventListener('input', function () { toggleButtons(this.value); });
//     cstBtn.addEventListener('click', function (e) {
//       const value = input.value.trim();
//       const floatVal = parseFloat(value);
//       clearError();
//       if (!value || floatVal <= 0) {
//         e.preventDefault();
//         showError('Please enter product quantity.');
//         return;
//       }
//       if (!Number.isInteger(floatVal)) {
//         e.preventDefault();
//         const floor = Math.floor(floatVal);
//         const ceil = Math.ceil(floatVal);
//         showError(`Please enter a valid value. The two nearest valid values are ${floor} and ${ceil}.`);
//         return;
//       }
//       if (!isSoldOut) themeBtn.click();
//     });
//     toggleButtons(input.value);
//   }

//   // Reset total price on load
//   setTimeout(() => {
//     const prefilledBoxes = parseFloat(boxesInput.value);
//     if (prefilledBoxes > 0) {
//       boxesInput.dispatchEvent(new Event('input', { bubbles: true }));
//     } else {
//       totalPriceElement.textContent = '$0.00';
//       coverageMessage.style.display = 'block';
//     }
//   }, 50);
//   });








//   const productImg = container.querySelector('.product-img');
//   const productThumb = container.querySelector('.product-thumb');

//   if (productImg && !$(productImg).hasClass('slick-initialized')) {
//     $(productImg).slick({
//       autoplay: false,
//       slidesToShow: 1,
//       arrows: false,
//       infinite: false,
//       asNavFor: productThumb ? '.product-thumb' : null,
//       adaptiveHeight: true
//     });
//   }

//   if (productThumb && !$(productThumb).hasClass('slick-initialized')) {
//     $(productThumb).slick({
//       slidesToShow: 5.6,
//       slidesToScroll: 1,
//       infinite: false,
//       prevArrow: `<button class="slick-prev slick-arrow">
//         <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//           <path d="M3.25032 19.9971L0.916992 17.6637L8.58366 9.99707L0.916992 2.3304L3.25032 -0.00292969L13.2503 9.99707L3.25032 19.9971Z" fill="#8F7401"/>
//         </svg>
//       </button>`,
//       nextArrow: `<button class="slick-next slick-arrow">
//         <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//           <path d="M3.25032 19.9971L0.916992 17.6637L8.58366 9.99707L0.916992 2.3304L3.25032 -0.00292969L13.2503 9.99707L3.25032 19.9971Z" fill="#8F7401"/>
//         </svg>
//       </button>`,
//       focusOnSelect: true
//     });

//     // Thumbnail click → Go to main image
//     $(productThumb).on('click', '.slick-slide', function () {
//       const index = $(this).data('slick-index');
//       $(productImg).slick('slickGoTo', index);
//     });
//   }
//   if (productImg) {
//     $(productImg).on('afterChange', function (event, slick, currentSlide) {
//       if (productThumb) {
//         $('.product-thumb .slick-slide').removeClass('slick-current');
//         $(`.product-thumb .slick-slide[data-slick-index="${currentSlide}"]`).addClass('slick-current');
//       }
//       $('.zoomContainer').remove();
//     });
//   }  
// }

// if (!customElements.get('quick-add-modal')) {
//   customElements.define(
//     'quick-add-modal',
//     class QuickAddModal extends ModalDialog {
//       constructor() {
//         super();
//         this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

//         this.addEventListener('product-info:loaded', ({ target }) => {
//           target.addPreProcessCallback(this.preprocessHTML.bind(this));
//         });

       
//       }

//       hide(preventFocus = false) {
//         const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         if (cartNotification) cartNotification.setActiveElement(this.openedBy);
//         this.modalContent.innerHTML = '';

//         if (preventFocus) this.openedBy = null;
//         super.hide();
//       }

//       show(opener) {
//         opener.setAttribute('aria-disabled', true);
//         opener.classList.add('loading');
//         opener.querySelector('.loading__spinner').classList.remove('hidden');

//         fetch(opener.getAttribute('data-product-url'))
//           .then((response) => response.text())
//           .then((responseText) => {
//             const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
//             const productElement = responseHTML.querySelector('product-info');

//             this.preprocessHTML(productElement);
//             HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

//             // initTileCalculator();
//             // setTimeout(()=>{
              
//             // },1000);
//             initTileCalculator(this.modalContent);
//             if (window.Shopify && Shopify.PaymentButton) {
//               Shopify.PaymentButton.init();
//             }
//             if (window.ProductModel) window.ProductModel.loadShopifyXR();

//             super.show(opener);
//           })
//           .finally(() => {
//             opener.removeAttribute('aria-disabled');
//             opener.classList.remove('loading');
//             opener.querySelector('.loading__spinner').classList.add('hidden');
//           });
//       }

//       preprocessHTML(productElement) {
//         productElement.classList.forEach((classApplied) => {
//           if (classApplied.startsWith('color-') || classApplied === 'gradient')
//             this.modalContent.classList.add(classApplied);
//         });
//         this.preventDuplicatedIDs(productElement);
//         this.removeDOMElements(productElement);
//         this.removeGalleryListSemantic(productElement);
//         this.updateImageSizes(productElement);
//         this.preventVariantURLSwitching(productElement);
//       }

//       preventVariantURLSwitching(productElement) {
//         productElement.setAttribute('data-update-url', 'false');
//       }

//       removeDOMElements(productElement) {
//         const pickupAvailability = productElement.querySelector('pickup-availability');
//         if (pickupAvailability) pickupAvailability.remove();

//         const productModal = productElement.querySelector('product-modal');
//         if (productModal) productModal.remove();

//         const modalDialog = productElement.querySelectorAll('modal-dialog');
//         if (modalDialog) modalDialog.forEach((modal) => modal.remove());
//       }

//       preventDuplicatedIDs(productElement) {
//         const sectionId = productElement.dataset.section;

//         const oldId = sectionId;
//         const newId = `quickadd-${sectionId}`;
//         productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
//         Array.from(productElement.attributes).forEach((attribute) => {
//           if (attribute.value.includes(oldId)) {
//             productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
//           }
//         });

//         productElement.dataset.originalSection = sectionId;
//       }

//       removeGalleryListSemantic(productElement) {
//         const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
//         if (!galleryList) return;

//         galleryList.setAttribute('role', 'presentation');
//         galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
//       }

//       updateImageSizes(productElement) {
//         const product = productElement.querySelector('.product');
//         const desktopColumns = product?.classList.contains('product--columns');
//         if (!desktopColumns) return;

//         const mediaImages = product.querySelectorAll('.product__media img');
//         if (!mediaImages.length) return;

//         let mediaImageSizes =
//           '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

//         if (product.classList.contains('product--medium')) {
//           mediaImageSizes = mediaImageSizes.replace('715px', '605px');
//         } else if (product.classList.contains('product--small')) {
//           mediaImageSizes = mediaImageSizes.replace('715px', '495px');
//         }

//         mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
//       }

     
//     }
//   );
// }



/* ===============================
   HOOK INTO QUICK ADD MODAL
   =============================== */
function initTileCalculator(container) {
  const infoElems = container.querySelectorAll(':scope .product__info-container');
  infoElems.forEach((infoElem)=>{

  console.log("infoElem",infoElem);

  const wrapper = infoElem.querySelector('.coverage-with-boxes-input-main');
  if (!wrapper) return;

  const sqftInput = infoElem.querySelector('.input-field-sqft');
  console.log("sqftInput",sqftInput);
  const boxesInput = infoElem.querySelector('.input-field-qut');
  const wastageCheckbox = container.querySelector('.wastage-checkbox input[type="checkbox"]');
  console.log("wastageCheckbox",wastageCheckbox);
  const errorDiv = infoElem.querySelector('.error-add');
  const calculatorWrapper = infoElem.querySelector('#product-calculator');
  const totalPriceElement = infoElem.querySelector('#total-price');
  const coverageMessage = infoElem.querySelector('#product-coverage');
  const oneBoxPrice = parseFloat(wrapper.getAttribute('one-box-price')) / 100 || 0;
  const themeBtn = infoElem.querySelector('.theme-btn');
  const cstBtn = infoElem.querySelector('.cst-btn');
  const shopifyQuantityInput = infoElem.querySelector('.quantity__input');

  if (!sqftInput || !boxesInput || !wastageCheckbox) return;

  const sqftPerBox = parseFloat(wrapper.dataset.sqftPerBox) || 1;
  let rawSqft = 0;
  let manualSqftValue = 0;
  let isSyncing = false;

  function clearError() {
    if (calculatorWrapper && errorDiv) {
      calculatorWrapper.classList.remove('error-box');
      errorDiv.innerHTML = '';
      errorDiv.style.display = 'none';
    }
  }

  function showError(message) {
    if (!calculatorWrapper || !errorDiv) return;

    // Prevent quick-add modal from writing to main product's errorDiv
    if (!container.contains(errorDiv)) return;

    const errorIcon = `
      <svg height="20" width="20" style="overflow:visible;enable-background:new 0 0 32 32; vertical-align: middle; margin-right: 6px;" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <g id="Error_1_">
          <g id="Error">
            <circle cx="16" cy="16" r="16" style="fill:#D72828;" />
            <path d="M14.5,25h3v-3h-3V25z M14.5,6v13h3V6H14.5z" style="fill:#E6E6E6;" />
          </g>
        </g>
      </svg>
    `;
    errorDiv.innerHTML = `
      <div class="error-msg" style="display:flex; align-items:center; gap: 6px;">
        ${errorIcon}<span>${message}</span>
      </div>
    `;
    console.log("errorDiv111",errorDiv);
    errorDiv.style.display = 'block';
    calculatorWrapper.classList.add('error-box');
  }



  function updateTotalAndCoverage() {
    const boxes = parseFloat(boxesInput.value) || 0;
    const total = boxes * oneBoxPrice;
    totalPriceElement.textContent = `$${total.toFixed(2)}`;
    coverageMessage.style.display = boxes > 0 ? 'none' : 'block';
  }




  // Prevent wastage check if no input
  wastageCheckbox.addEventListener('change', function () {
    console.log("checkbox changed...");
    let sqft = parseFloat(sqftInput.value) || 0;
    let boxes = parseFloat(boxesInput.value) || 0;
    if (this.checked && sqft <= 0 && boxes <= 0) {
      this.checked = false;
      showError('Please enter a valid Sqft or Boxes before applying 10% wastage.');
      isSyncing = false;
    }
  });

  // SQFT → BOXES
  sqftInput.addEventListener('input', function () {
    clearError();
    if (isSyncing) return;
    isSyncing = true;
    let sqft = parseFloat(sqftInput.value) || 0;
    manualSqftValue = wastageCheckbox.checked ? sqft / 1.1 : sqft;
    rawSqft = manualSqftValue;
    if (rawSqft > 0) {
      const boxes = Math.ceil(rawSqft / sqftPerBox);
      boxesInput.value = boxes;
      boxesInput.dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      boxesInput.value = '';
      boxesInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
    sqftInput.dispatchEvent(new Event('change', { bubbles: true }));
    updateTotalAndCoverage();
    isSyncing = false;
  });

  // BOXES → SQFT
  boxesInput.addEventListener('input', function () {
    clearError();
    if (isSyncing) return;
    isSyncing = true;
    const boxes = parseFloat(boxesInput.value) || 0;
    if (boxes <= 0) {
      sqftInput.value = '';
      updateTotalAndCoverage();
      if (wastageCheckbox.checked) {
        wastageCheckbox.checked = false;
        showError('10% wastage removed — box quantity must be greater than 0.');
      }
      isSyncing = false;
      return;
    }
    rawSqft = boxes * sqftPerBox;
    manualSqftValue = rawSqft;
    sqftInput.value = wastageCheckbox.checked ? (rawSqft * 1.1).toFixed(2) : rawSqft.toFixed(2);
    sqftInput.dispatchEvent(new Event('input', { bubbles: true }));
    sqftInput.dispatchEvent(new Event('change', { bubbles: true }));
    updateTotalAndCoverage();
    isSyncing = false;
  });

  // WASTAGE CHECKBOX CHANGE
  wastageCheckbox.addEventListener('change', function () {
    if (isSyncing) return;
    isSyncing = true;
    let sqft = manualSqftValue || 0;
    sqft = wastageCheckbox.checked ? sqft * 1.1 : sqft;
    sqftInput.value = sqft.toFixed(2);
    const displayedSqft = parseFloat(sqftInput.value) || 0;
    const boxes = displayedSqft > 0 ? Math.ceil(displayedSqft / sqftPerBox) : '';
    boxesInput.value = boxes;
    sqftInput.dispatchEvent(new Event('change', { bubbles: true }));
    updateTotalAndCoverage();
    if (shopifyQuantityInput) shopifyQuantityInput.value = boxes;
    isSyncing = false;
  });

  // Quantity pass to cart
  boxesInput.addEventListener('input', function () {
    const boxValue = parseInt(boxesInput.value);
    if (shopifyQuantityInput) shopifyQuantityInput.value = (!isNaN(boxValue) && boxValue >= 1) ? boxValue : 0;
  });

  // Validation for custom button
  if (themeBtn && cstBtn) {
    const isSoldOut = themeBtn.hasAttribute('disabled');
    function toggleButtons(value) {
      const floatVal = parseFloat(value);
      if (!value || floatVal <= 0 || !Number.isInteger(floatVal)) {
        if (!isSoldOut) {
          themeBtn.hidden = true;
          cstBtn.style.display = 'block';
        }
      } else {
        if (!isSoldOut) {
          themeBtn.hidden = false;
          cstBtn.style.display = 'none';
        }
      }
      clearError();
    }
    input = boxesInput;
    input.addEventListener('input', function () { toggleButtons(this.value); });
    cstBtn.addEventListener('click', function (e) {
      const value = input.value.trim();
      const floatVal = parseFloat(value);
      clearError();
      if (!value || floatVal <= 0) {
        e.preventDefault();
        showError('Please enter product quantity.');
        return;
      }
      if (!Number.isInteger(floatVal)) {
        e.preventDefault();
        const floor = Math.floor(floatVal);
        const ceil = Math.ceil(floatVal);
        showError(`Please enter a valid value. The two nearest valid values are ${floor} and ${ceil}.`);
        return;
      }
      if (!isSoldOut) themeBtn.click();
    });
    toggleButtons(input.value);
  }

  // Reset total price on load
  setTimeout(() => {
    const prefilledBoxes = parseFloat(boxesInput.value);
    if (prefilledBoxes > 0) {
      boxesInput.dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      totalPriceElement.textContent = '$0.00';
      coverageMessage.style.display = 'block';
    }
  }, 50);
  });

function getVisibleElement(elements) {
  return Array.from(elements).find(el => {
    return el.offsetParent !== null; // element is visible in DOM
  });
}






 const productImgs = container.querySelectorAll('.product-img');
  const productThumb = container.querySelector('.product-thumb');

  // Pick ONLY the visible .product-img (desktop or mobile)
  const productImg = getVisibleElement(productImgs);

  if (!productImg) {
    console.warn("No visible .product-img found");
    return;
  }

  // DESTROY existing
  if ($(productImg).hasClass('slick-initialized')) $(productImg).slick('unslick');
  if (productThumb && $(productThumb).hasClass('slick-initialized')) $(productThumb).slick('unslick');

  if (productImg) {
    $(productImg).slick({
      autoplay: false,
      slidesToShow: 1,
      arrows: false,
      infinite: false,
      asNavFor: productThumb ? '.product-thumb' : null,
      adaptiveHeight: true
    });
  }

  if (productThumb) {
    $(productThumb).slick({
      slidesToShow: 5.6,
      slidesToScroll: 1,
      infinite: false,
      prevArrow: `<button class="slick-prev slick-arrow">
        <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.25032 19.9971L0.916992 17.6637L8.58366 9.99707L0.916992 2.3304L3.25032 -0.00292969L13.2503 9.99707L3.25032 19.9971Z" fill="#8F7401"/>
        </svg>
      </button>`,
      nextArrow: `<button class="slick-next slick-arrow">
        <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.25032 19.9971L0.916992 17.6637L8.58366 9.99707L0.916992 2.3304L3.25032 -0.00292969L13.2503 9.99707L3.25032 19.9971Z" fill="#8F7401"/>
        </svg>
      </button>`,
      focusOnSelect: true
    });

    // Thumbnail click → Go to main image
    $(productThumb).on('click', '.slick-slide', function () {
      const index = $(this).data('slick-index');
      $(productImg).slick('slickGoTo', index);
    });
  }
  if (productImg) {
    $(productImg).on('afterChange', function (event, slick, currentSlide) {
      if (productThumb) {
        $('.product-thumb .slick-slide').removeClass('slick-current');
        $(`.product-thumb .slick-slide[data-slick-index="${currentSlide}"]`).addClass('slick-current');
      }
      $('.zoomContainer').remove();
    });
  }  
}

if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });

       
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            // initTileCalculator();
            // setTimeout(()=>{
              
            // },1000);
            initTileCalculator(this.modalContent);
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

     
    }
  );
}

